import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XCircle, CheckCircle2, ChevronDown, Shield, Star, FileText, Zap, BookOpen, Download, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-navy selection:bg-electric selection:text-white" data-id="element-23">
      <main data-id="element-24">
        {/* SECCIÓN 1 — HERO */}
        <section className="bg-navy text-white px-4 relative overflow-hidden md:pt-16 md:pb-20" data-id="element-25">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-electric/20 via-navy to-navy pointer-events-none" data-id="element-26"></div>

          {/* ABOVE-THE-FOLD CONTAINER — fits in one iPhone viewport */}
          <div className="min-h-[100svh] md:min-h-0 flex flex-col justify-center py-3 md:py-0 max-w-5xl mx-auto text-center relative z-10 w-full" data-id="element-27">
            <div className="inline-block self-center bg-orange/10 border border-orange/30 text-orange font-bold px-3 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] md:text-sm tracking-wide mb-2 md:mb-4" data-id="element-28">
              PROFE LISTO · EDUCACIÓN FÍSICA 360
            </div>

            {/* 5-star reviews row */}
            <div className="flex items-center justify-center gap-1.5 md:gap-2 mb-2 md:mb-6 text-[11px] md:text-sm" data-id="element-29">
              <div className="flex gap-0.5" data-id="element-30">
                {[...Array(5)].map((_, i) => <Star key={i} size={13} className="fill-orange text-orange md:w-4 md:h-4" data-id="element-31" />)}
              </div>
              <span className="font-bold text-white" data-id="element-32">4.9/5</span>
              <span className="text-gray-400" data-id="element-33">· +300 profes confían</span>
            </div>

            <h1 className="text-[26px] leading-[1.1] md:text-5xl lg:text-6xl font-black md:leading-tight mb-2 md:mb-8 tracking-tight px-2 md:px-0" data-id="element-34">
              Todo tu año de Educación Física resuelto de una vez.
            </h1>

            <div className="flex justify-center mb-2 md:mb-8" data-id="element-35">
              <img src="https://cdn.magicpatterns.com/uploads/vJJzvnEiF4tN4hfJCbijoA/270.png" alt="Megapack Educación Física 360 — Colección Completa Elite Edition" className="w-auto max-h-[42vh] md:max-h-none md:w-full md:max-w-lg lg:max-w-xl object-contain drop-shadow-[0_25px_50px_rgba(255,107,53,0.35)]" data-id="element-36" />
            </div>

            <p className="text-electric text-[13px] md:text-2xl font-medium max-w-3xl mx-auto mb-3 md:mb-10 leading-snug md:leading-relaxed px-2 md:px-0" data-id="element-37">
              Megapack EF360 — El sistema completo de actividades,
              planificaciones y recursos para el profesor de Educación Física
              argentino
            </p>

            {/* Feature badges — small inline pills on mobile, full pills on desktop */}
            <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 md:gap-8 mb-3 md:mb-12 text-[11px] md:text-base font-medium" data-id="element-38">
              <span className="flex items-center gap-1 md:gap-2 md:bg-white/5 md:px-4 md:py-2 md:rounded-full md:border md:border-white/10" data-id="element-39">
                <FileText size={12} className="text-orange md:w-[18px] md:h-[18px]" data-id="element-40" />{' '}
                PDF
              </span>
              <span className="text-white/30 md:hidden" data-id="element-41">|</span>
              <span className="flex items-center gap-1 md:gap-2 md:bg-white/5 md:px-4 md:py-2 md:rounded-full md:border md:border-white/10" data-id="element-42">
                <Zap size={12} className="text-orange md:w-[18px] md:h-[18px]" data-id="element-43" />{' '}
                Acceso Inmediato
              </span>
              <span className="text-white/30 md:hidden" data-id="element-44">|</span>
              <span className="flex items-center gap-1 md:gap-2 md:bg-white/5 md:px-4 md:py-2 md:rounded-full md:border md:border-white/10" data-id="element-45">
                <BookOpen size={12} className="text-orange md:w-[18px] md:h-[18px]" data-id="element-46" />{' '}
                12 Tomos + 6 Bonus + 2 Élite
              </span>
            </div>

            <a href="#precio" className="inline-flex items-center justify-center gap-2 md:gap-3 bg-orange hover:bg-orange-hover text-white font-black text-base md:text-2xl py-3 md:py-5 px-6 md:px-12 rounded-full transition-all shadow-[0_0_40px_rgba(255,107,53,0.4)] hover:shadow-[0_0_60px_rgba(255,107,53,0.6)] hover:-translate-y-1 w-full md:w-auto" data-id="element-47">
              💪 QUIERO MI EF360 AHORA
            </a>

            <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 md:gap-6 mt-2 md:mt-6 text-[10px] md:text-sm text-gray-400" data-id="element-48">
              <span className="flex items-center gap-1.5" data-id="element-49">
                <Shield size={12} className="md:w-4 md:h-4" data-id="element-50" /> Garantía 7 días
              </span>
              <span data-id="element-51">|</span>
              <span className="flex items-center gap-1.5" data-id="element-52">
                <Lock size={12} className="md:w-4 md:h-4" data-id="element-53" /> Pago seguro
              </span>
              <span className="hidden md:inline" data-id="element-54">|</span>
              <span className="hidden md:flex items-center gap-1.5" data-id="element-55">
                <CreditCard size={16} data-id="element-56" /> Tarjetas y transferencia
              </span>
            </div>
          </div>

          {/* CONTINUATION — visible only when scrolling past the fold */}
          <div className="max-w-5xl mx-auto text-center relative z-10 w-full" data-id="element-57">
            {/* Trust Bar */}
            <div className="mt-20 border-t border-b border-white/10 py-8" data-id="element-58">
              <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10" data-id="element-59">
                <div className="flex flex-col items-center justify-center px-4" data-id="element-60">
                  <span className="text-3xl font-black text-white mb-1" data-id="element-61">
                    +300
                  </span>
                  <span className="text-xs text-gray-400 uppercase tracking-wider text-center" data-id="element-62">
                    profes confían
                  </span>
                </div>
                <div className="flex flex-col items-center justify-center px-4" data-id="element-63">
                  <span className="text-3xl font-black text-white mb-1" data-id="element-64">
                    12+6
                  </span>
                  <span className="text-xs text-gray-400 uppercase tracking-wider text-center" data-id="element-65">
                    Tomos + Bonus
                  </span>
                </div>
                <div className="flex flex-col items-center justify-center px-4 col-span-2 md:col-span-1" data-id="element-66">
                  <span className="text-3xl font-black text-white mb-1 flex items-center gap-1" data-id="element-67">
                    4.9/5 <Star className="fill-orange text-orange" size={20} data-id="element-68" />
                  </span>
                  <span className="text-xs text-gray-400 uppercase tracking-wider text-center" data-id="element-69">
                    calificación
                  </span>
                </div>
                <div className="flex flex-col items-center justify-center px-4" data-id="element-70">
                  <span className="text-3xl font-black text-white mb-1" data-id="element-71">
                    🇦🇷
                  </span>
                  <span className="text-xs text-gray-400 uppercase tracking-wider text-center" data-id="element-72">
                    Argentina
                  </span>
                </div>
                <div className="flex flex-col items-center justify-center px-4" data-id="element-73">
                  <span className="text-3xl font-black text-white mb-1" data-id="element-74">
                    🛡️
                  </span>
                  <span className="text-xs text-gray-400 uppercase tracking-wider text-center" data-id="element-75">
                    Garantía 7 días
                  </span>
                </div>
              </div>
            </div>

            {/* Testimonials Hero */}
            <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-76">
              {[{
              init: 'MP',
              quote: '"Organicé todo el mes en una tarde. Nunca más llego a clase sin saber qué actividad voy a dar."',
              name: 'María P., Buenos Aires',
              role: 'Profesora de EF en Escuela Primaria'
            }, {
              init: 'CG',
              quote: '"Mis alumnos de 1° primaria mejoraron su coordinación desde la primera semana con el Tomo 1."',
              name: 'Carlos G., Córdoba',
              role: 'Profesor de EF en Escuela Secundaria'
            }, {
              init: 'FR',
              quote: '"Antes tardaba 1 hora planificando la clase del día siguiente. Ahora son 5 minutos."',
              name: 'Fernanda R., Rosario',
              role: 'Profesora de EF Nivel Primario y Sec.'
            }].map((t, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-xl relative" data-id="element-77">
                  <div className="absolute -top-5 left-6 w-10 h-10 bg-orange rounded-full flex items-center justify-center text-white font-bold text-sm border-4 border-navy" data-id="element-78">
                    {t.init}
                  </div>
                  <p className="text-navy font-medium italic mt-4 mb-4 text-sm leading-relaxed" data-id="element-79">
                    {t.quote}
                  </p>
                  <div data-id="element-80">
                    <p className="font-bold text-navy text-sm" data-id="element-81">{t.name}</p>
                    <p className="text-xs text-gray-500 mt-0.5" data-id="element-82">{t.role}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 2 — DOLOR */}
        <section className="py-20 px-4 bg-white" data-id="element-83">
          <div className="max-w-4xl mx-auto" data-id="element-84">
            <p className="text-center text-teal-600 font-bold tracking-wide text-sm mb-10 uppercase" data-id="element-85">
              Si sos profe de Educación Física, esto te va a sonar conocido:
            </p>

            <div className="space-y-3 mb-16" data-id="element-86">
              {['Llegás el domingo a la noche sin saber qué vas a dar el lunes a primera hora', 'Tus alumnos no progresan porque no hay un orden claro de contenidos entre clase y clase', 'Tenés grupos con niveles muy distintos y no sabés cómo manejarlos sin que nadie quede afuera', 'Cuando llueve o hay feriado perdés la continuidad y la clase se convierte en un caos improvisado', 'No podés justificar tu valor como docente porque no tenés nada sistematizado ni documentado', 'Algún alumno con certificado médico se sienta en el banco y no sabés qué darle para que no sea un problema con los padres', 'Te piden ESI y EAI en la planificación y no sabés cómo integrarlo a una clase de Educación Física', 'Terminás cada clase agotado/a porque manejaste el caos del grupo más que la clase en sí'].map((pain, i, arr) => <div key={i} className={`flex items-start gap-4 p-5 rounded-xl ${i === arr.length - 1 ? 'bg-red-50 border border-red-100' : 'bg-[#FFF5F5]'}`} data-id="element-87">
                  <XCircle className="text-red-500 shrink-0 mt-0.5" size={24} data-id="element-88" />
                  <p className="text-navy font-semibold md:text-lg leading-snug" data-id="element-89">
                    {pain}
                  </p>
                </div>)}
            </div>

            <div className="text-center" data-id="element-90">
              <span className="text-6xl text-orange font-serif leading-none block mb-[-20px]" data-id="element-91">
                "
              </span>
              <h3 className="text-2xl md:text-3xl font-black italic text-navy mb-10" data-id="element-92">
                ¿Cuántas clases más vas a llegar sin tener todo listo?
              </h3>
              <a href="#precio" className="inline-flex items-center justify-center gap-3 bg-orange hover:bg-orange-hover text-white font-bold text-lg py-4 px-8 rounded-full transition-all shadow-lg hover:-translate-y-1 w-full md:w-auto" data-id="element-93">
                👉 BASTA DE IMPROVISAR — QUIERO MI EF360
              </a>
            </div>
          </div>
        </section>

        {/* SECCIÓN 3 — SOLUCIÓN + AUTORIDAD */}
        <section className="bg-navy py-20 px-4 text-center" data-id="element-94">
          <div className="max-w-5xl mx-auto" data-id="element-95">
            <div className="text-5xl mb-6" data-id="element-96">🏆</div>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-97">
              El Sistema N°1 para Profesores de Educación Física Argentinos
            </h2>
            <p className="text-electric text-lg md:text-xl font-medium mb-12 max-w-3xl mx-auto" data-id="element-98">
              EF360 — Colección Completa 12 Tomos + 6 Bonus + 2 Élite — Todo
              resuelto, todos los niveles, toda la escolaridad.
            </p>

            <div className="flex flex-col md:flex-row justify-center gap-6" data-id="element-99">
              {[{
              num: '+280',
              label: 'páginas'
            }, {
              num: '+150',
              label: 'actividades graficadas'
            }, {
              num: '100%',
              label: 'Primaria y Secundaria completa'
            }].map((stat, i) => <div key={i} className="bg-white rounded-2xl p-8 shadow-xl flex-1 transform hover:-translate-y-1 transition-transform" data-id="element-100">
                  <div className="text-4xl md:text-5xl font-black text-orange mb-2" data-id="element-101">
                    {stat.num}
                  </div>
                  <div className="text-navy font-bold text-sm uppercase tracking-wide" data-id="element-102">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 4 — LOS 12 TOMOS */}
        <section className="py-20 px-4 bg-white" data-id="element-103">
          <div className="max-w-6xl mx-auto" data-id="element-104">
            <div className="text-center mb-16" data-id="element-105">
              <h2 className="text-4xl md:text-5xl font-black text-navy mb-4" data-id="element-106">
                Los 12 Tomos Completos
              </h2>
              <p className="text-xl text-gray-600 font-medium" data-id="element-107">
                Actividades graficadas · Por año escolar y nivel · Listo para
                usar mañana
              </p>
            </div>

            {/* Primaria */}
            <div className="mb-16" data-id="element-108">
              <div className="bg-navy text-white text-center py-4 rounded-xl font-black text-xl tracking-widest mb-8 shadow-md" data-id="element-109">
                PRIMARIA — TOMOS 1 AL 6
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-110">
                {[{
                n: 1,
                title: '1° Primaria',
                desc: 'Descubrimiento del cuerpo y el espacio. Juegos de esquema corporal, lateralidad y primeras nociones de movimiento.'
              }, {
                n: 2,
                title: '2° Primaria',
                desc: 'Habilidades con pelota y coordinación básica. Juegos de equipo para los primeros colectivos.'
              }, {
                n: 3,
                title: '3° Primaria',
                desc: 'Pre-deporte, juegos de invasión y liderazgo grupal. El primer acercamiento a lo táctico.'
              }, {
                n: 4,
                title: '4° Primaria',
                desc: 'Atletismo, juegos de red y condición física inicial. El cuerpo que empieza a rendir.'
              }, {
                n: 5,
                title: '5° Primaria',
                desc: 'Deportes colectivos, gimnasia básica y táctica grupal. El alumno que empieza a comprender el juego.'
              }, {
                n: 6,
                title: '6° Primaria',
                desc: 'Cierre del ciclo primario. Deportes reglamentados, autonomía y graduación. Incluye diploma de completación.'
              }].map(tomo => <div key={tomo.n} className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-[0_8px_30px_rgba(0,102,255,0.12)] transition-all group relative overflow-hidden" data-id="element-111">
                    <div className="absolute top-0 left-0 w-1 h-full bg-orange" data-id="element-112"></div>
                    <div className="inline-block bg-orange text-white text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-113">
                      TOMO {tomo.n}
                    </div>
                    <h3 className="text-xl font-black text-navy mb-2 group-hover:text-electric transition-colors" data-id="element-114">
                      {tomo.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-115">
                      {tomo.desc}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Secundaria */}
            <div className="mb-16" data-id="element-116">
              <div className="bg-navy text-white text-center py-4 rounded-xl font-black text-xl tracking-widest mb-8 shadow-md" data-id="element-117">
                SECUNDARIA — TOMOS 7 AL 12
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-118">
                {[{
                n: 7,
                title: '1° Secundaria',
                desc: 'Condición física, deportes formales e introducción al entrenamiento.'
              }, {
                n: 8,
                title: '2° Secundaria',
                desc: 'Especialización deportiva, entrenamiento por objetivos y táctica intermedia.'
              }, {
                n: 9,
                title: '3° Secundaria',
                desc: 'Sistemas tácticos avanzados, alto rendimiento y proyecto deportivo personal.'
              }, {
                n: 10,
                title: '4° Secundaria',
                desc: 'Liderazgo deportivo, preparación física de competencia y análisis profesional.'
              }, {
                n: 11,
                title: '5° Secundaria',
                desc: 'Gran final, proyecto deportivo en acción y legado personal del alumno.'
              }, {
                n: 12,
                title: '6° Secundaria',
                desc: 'Cierre del ciclo completo. Graduación, legado y deportista para toda la vida. Incluye diploma final EF360.'
              }].map(tomo => <div key={tomo.n} className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-[0_8px_30px_rgba(0,102,255,0.12)] transition-all group relative overflow-hidden" data-id="element-119">
                    <div className="absolute top-0 left-0 w-1 h-full bg-electric" data-id="element-120"></div>
                    <div className="inline-block bg-orange text-white text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-121">
                      TOMO {tomo.n}
                    </div>
                    <h3 className="text-xl font-black text-navy mb-2 group-hover:text-electric transition-colors" data-id="element-122">
                      {tomo.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-123">
                      {tomo.desc}
                    </p>
                  </div>)}
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4" data-id="element-124">
              {[{
              icon: '✏️',
              text: 'Actividades graficadas en cada tomo'
            }, {
              icon: '⚡',
              text: 'Sistema "Abrí y Dictás"'
            }, {
              icon: '📋',
              text: 'Fichas listas para imprimir'
            }, {
              icon: '🇦🇷',
              text: 'Contenido 100% adaptado a Argentina'
            }].map((feat, i) => <div key={i} className="bg-blue-50 text-navy font-bold px-5 py-3 rounded-full text-sm flex items-center gap-2 border border-blue-100" data-id="element-125">
                  <span data-id="element-126">{feat.icon}</span> {feat.text}
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 5 — LOS 6 BONUS */}
        <section className="py-20 px-4 bg-[#FAF7F2]" data-id="element-127">
          <div className="max-w-6xl mx-auto" data-id="element-128">
            <div className="text-center mb-12" data-id="element-129">
              <h2 className="text-4xl md:text-5xl font-black text-navy mb-4 tracking-tight" data-id="element-130">
                + 6 Regalos Estratégicos
              </h2>
              <p className="text-lg md:text-xl text-gray-500 font-medium mb-8 max-w-xl mx-auto" data-id="element-131">
                Incluidos sin costo extra · Valor real del pack
              </p>
              <div className="inline-flex items-center gap-2 bg-orange text-white font-black px-6 py-3 rounded-full text-sm md:text-base shadow-lg animate-pulse" data-id="element-132">
                🎁 GRATIS POR EL DÍA DE HOY
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-133">
              {[{
              emoji: '📊',
              num: 1,
              title: 'Bonus 1 — La Planilla Maestra de Notas',
              desc: 'Detectá en segundos quién está en riesgo de desaprobar. Fórmulas automáticas para 200 alumnos. Sin cálculo manual.',
              color: '#2C5F7C',
              spine: '#1F4458'
            }, {
              emoji: '🚨',
              num: 2,
              title: 'Bonus 2 — Actividades de Emergencia',
              desc: '15 actividades listas para usar cuando todo falla. Sin patio, sin material, sin tiempo de preparación.',
              color: '#B8423C',
              spine: '#8C2F2A'
            }, {
              emoji: '🎒',
              num: 3,
              title: 'Bonus 3 — Clases Sin Presupuesto',
              desc: 'Cómo improvisar objetos y dar clases increíbles sin gastar un peso. 20 sustitutos de materiales listos.',
              color: '#D97B3A',
              spine: '#A85920'
            }, {
              emoji: '🧠',
              num: 4,
              title: 'Bonus 4 — Guía de Inclusión y Adaptaciones',
              desc: 'Cómo adaptar cualquier actividad para que NINGÚN alumno quede afuera. 5 perfiles · 5 protocolos.',
              color: '#6B4E8C',
              spine: '#4D3666'
            }, {
              emoji: '📅',
              num: 5,
              title: 'Bonus 5 — El Planificador Anual del Profe',
              desc: '52 semanas organizadas. Nunca más empezar el lunes sin saber qué dar.',
              color: '#5C8A4C',
              spine: '#3F6334'
            }, {
              emoji: '📋',
              num: 6,
              title: 'Bonus 6 — Pack de Plantillas de Seguimiento',
              desc: 'Detectá rápido quién está flojo, quién mejoró y quién necesita ayuda antes de desaprobar.',
              color: '#3D7A8C',
              spine: '#28586A'
            }].map((bonus, i) => <div key={i} className="bg-white rounded-3xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.12)] hover:-translate-y-2 transition-all duration-300 p-8 flex flex-col items-center text-center" data-id="element-134">
                  {/* Book mockup */}
                  <div className="mb-6 relative" style={{
                perspective: '1000px'
              }} data-id="element-135">
                    <div className="relative rounded-r-lg rounded-l-md overflow-hidden shadow-2xl" style={{
                  width: '170px',
                  height: '230px',
                  backgroundColor: bonus.color,
                  boxShadow: `0 20px 40px -10px ${bonus.color}66, 0 8px 16px rgba(0,0,0,0.15)`
                }} data-id="element-136">
                      {/* Spine on left */}
                      <div className="absolute top-0 left-0 h-full w-3" style={{
                    backgroundColor: bonus.spine
                  }} data-id="element-137"></div>
                      {/* Inner shadow line */}
                      <div className="absolute top-0 left-3 h-full w-px bg-black/10" data-id="element-138"></div>

                      {/* Book content */}
                      <div className="pl-7 pr-4 pt-6 pb-5 h-full flex flex-col justify-between text-white" data-id="element-139">
                        <div className="text-4xl" data-id="element-140">{bonus.emoji}</div>
                        <div className="text-left" data-id="element-141">
                          <div className="text-2xl font-black leading-tight mb-1" data-id="element-142">
                            Bonus {bonus.num}
                          </div>
                        </div>
                        <div data-id="element-143">
                          <div className="h-px bg-white/30 mb-2" data-id="element-144"></div>
                          <div className="text-[10px] font-bold tracking-widest opacity-80" data-id="element-145">
                            EF360™
                          </div>
                        </div>
                      </div>

                      {/* Subtle highlight */}
                      <div className="absolute top-0 left-3 right-0 h-1/3 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" data-id="element-146"></div>
                    </div>
                  </div>

                  {/* Gratis badge */}
                  <div className="inline-flex items-center gap-1.5 bg-green-50 text-green-700 font-black px-4 py-1.5 rounded-full text-xs tracking-wide border border-green-200 mb-4" data-id="element-147">
                    GRATIS
                  </div>

                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-black text-navy mb-3 leading-tight" data-id="element-148">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-500 text-sm md:text-base leading-relaxed" data-id="element-149">
                    {bonus.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 6 — CONTADOR + PRECIO */}
        <section id="precio" className="py-24 px-4 bg-navy text-white relative" data-id="element-150">
          <div className="max-w-6xl mx-auto relative z-10" data-id="element-151">
            <div className="text-center mb-12" data-id="element-152">
              <h2 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-153">
                ⏰ PRECIO DE LANZAMIENTO
                <br className="md:hidden" data-id="element-154" /> OFERTA POR TIEMPO LIMITADO
              </h2>

              <CountdownTimer data-id="element-155" />

              <div className="inline-flex items-center gap-2 bg-red-500/20 text-red-400 border border-red-500/30 px-4 py-2 rounded-full text-sm font-bold mt-2" data-id="element-156">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-ping absolute" data-id="element-157"></span>
                <span className="w-2 h-2 rounded-full bg-red-500 relative" data-id="element-158"></span>
                El precio sube cuando termina el contador
              </div>
            </div>

            <PricingSelector data-id="element-159" />
          </div>
        </section>

        {/* SECCIÓN 7 — LOS 2 EBOOKS ÉLITE */}
        <section className="py-20 px-4 bg-white" data-id="element-160">
          <div className="max-w-5xl mx-auto" data-id="element-161">
            <div className="text-center mb-16" data-id="element-162">
              <h2 className="text-3xl md:text-4xl font-black text-navy mb-4" data-id="element-163">
                ¿Qué agrega el Megapack Élite?
              </h2>
              <p className="text-electric text-lg md:text-xl font-medium max-w-2xl mx-auto" data-id="element-164">
                Por solo $9.000 más, resolvés los dos problemas que ningún
                recurso ataca.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-165">
              {/* Elite 1 */}
              <div className="bg-[#F3E8FF] rounded-2xl p-8 border-l-8 border-purple-500 shadow-lg flex flex-col h-full" data-id="element-166">
                <div className="text-5xl text-center mb-6" data-id="element-167">🧩</div>
                <h3 className="text-2xl font-black text-navy mb-4" data-id="element-168">
                  Élite 1 — El Plan B: Inclusión Real y SAF
                </h3>
                <p className="text-gray-600 italic mb-6 font-medium" data-id="element-169">
                  "El alumno que no quiere hacer EF no te está desafiando. Te
                  está pidiendo otra forma de ser parte."
                </p>
                <p className="text-navy leading-relaxed mb-6 flex-grow" data-id="element-170">
                  10 trabajos prácticos para alumnos con certificado médico ·
                  Roles alternativos de valor · Dinámicas sin competencia ·
                  Protocolo Anti-Celular · Ficha de seguimiento SAF lista para
                  archivar.
                </p>
                <p className="font-black text-purple-900 bg-purple-200/50 p-4 rounded-xl" data-id="element-171">
                  No improvises más cuando alguien trae el "certificado de
                  eximición".
                </p>
              </div>

              {/* Elite 2 */}
              <div className="bg-[#E8F5E9] rounded-2xl p-8 border-l-8 border-green-500 shadow-lg flex flex-col h-full" data-id="element-172">
                <div className="text-5xl text-center mb-6" data-id="element-173">🌱</div>
                <h3 className="text-2xl font-black text-navy mb-4" data-id="element-174">
                  Élite 2 — El Docente Transversal: ESI + EAI
                </h3>
                <p className="text-gray-600 italic mb-6 font-medium" data-id="element-175">
                  "El directivo te pide ESI y EAI en tu planificación."
                </p>
                <p className="text-navy leading-relaxed mb-6 flex-grow" data-id="element-176">
                  Este Ebook tiene el texto exacto para copiar y pegar en tu
                  PCI, los proyectos listos para dar en el patio y el registro
                  de cumplimiento para mostrar en cualquier inspección.
                </p>
                <p className="font-black text-green-900 bg-green-200/50 p-4 rounded-xl" data-id="element-177">
                  Cumplís la ley 26.150 y la 27.621 sin saber de qué se trata.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECCIÓN 8 — TABLA COMPARATIVA */}
        <section className="py-20 px-4 bg-[#F5F5F5]" data-id="element-178">
          <div className="max-w-4xl mx-auto" data-id="element-179">
            <h2 className="text-3xl md:text-4xl font-black text-navy text-center mb-12" data-id="element-180">
              ¿Cuánto cuesta NO tenerlo?
            </h2>

            <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-181">
              <div className="grid grid-cols-2" data-id="element-182">
                <div className="bg-red-500 text-white font-black text-center py-4 text-lg md:text-xl" data-id="element-183">
                  SIN EF360
                </div>
                <div className="bg-green-500 text-white font-black text-center py-4 text-lg md:text-xl" data-id="element-184">
                  CON EF360
                </div>
              </div>

              <div className="divide-y divide-gray-100" data-id="element-185">
                {[{
                bad: 'Domingo a la noche planificando desde cero',
                good: '5 minutos el domingo. Listo.'
              }, {
                bad: 'Actividades improvisadas sin progresión real',
                good: '+150 actividades graficadas por nivel'
              }, {
                bad: 'Grupos sin estructura ni continuidad',
                good: 'Un sistema claro para cada año escolar'
              }, {
                bad: 'El alumno con certificado te genera un problema',
                good: '10 TPs listos para entregar y calificar'
              }, {
                bad: 'Te piden ESI y EAI y no sabés qué poner',
                good: 'Texto listo para copiar en el PCI'
              }, {
                bad: 'Terminar cada semana agotado/a y sin rumbo',
                good: 'Llegás a clase con todo resuelto'
              }].map((row, i) => <div key={i} className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`} data-id="element-186">
                    <div className="p-4 md:p-6 bg-red-50/30 text-gray-500 italic text-sm md:text-base flex items-start gap-3" data-id="element-187">
                      <XCircle className="text-red-400 shrink-0 mt-0.5" size={18} data-id="element-188" />
                      {row.bad}
                    </div>
                    <div className="p-4 md:p-6 bg-green-50/30 text-navy font-bold text-sm md:text-base flex items-start gap-3" data-id="element-189">
                      <CheckCircle2 className="text-green-500 shrink-0 mt-0.5" size={18} data-id="element-190" />
                      {row.good}
                    </div>
                  </div>)}
              </div>

              <div className="bg-navy text-white text-center p-8" data-id="element-191">
                <p className="text-lg md:text-xl font-medium" data-id="element-192">
                  El lunes podés llegar sin nada. O podés llegar con todo
                  resuelto.
                </p>
                <p className="text-2xl md:text-3xl font-black text-orange mt-2" data-id="element-193">
                  Vos decidís.
                </p>
              </div>
            </div>

            <div className="text-center mt-12" data-id="element-194">
              <a href="#precio" className="inline-flex items-center justify-center gap-3 bg-orange hover:bg-orange-hover text-white font-black text-lg md:text-xl py-5 px-10 rounded-full transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1 w-full md:w-auto" data-id="element-195">
                NO QUIERO IMPROVISAR MÁS — DAME EL EF360
              </a>
            </div>
          </div>
        </section>

        {/* SECCIÓN 9 — TESTIMONIOS COMPLETOS */}
        <section className="py-20 px-4 bg-white" data-id="element-196">
          <div className="max-w-6xl mx-auto" data-id="element-197">
            <div className="text-center mb-16" data-id="element-198">
              <h2 className="text-3xl md:text-4xl font-black text-navy mb-4" data-id="element-199">
                Lo que dicen los profes
              </h2>
              <div className="flex items-center justify-center gap-2 text-2xl font-black text-navy" data-id="element-200">
                4.9/5 <Star className="fill-orange text-orange" size={28} data-id="element-201" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
              {[{
              init: 'MP',
              name: 'María P.',
              loc: 'Buenos Aires 🇦🇷',
              quote: '"Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más llego sin saber qué voy a dar."'
            }, {
              init: 'CG',
              name: 'Carlos G.',
              loc: 'Córdoba 🇦🇷',
              quote: '"Tres alumnos de 1° que estaban sin progreso mejoraron su coordinación en el primer mes usando el Tomo 1."'
            }, {
              init: 'FR',
              name: 'Fernanda R.',
              loc: 'Rosario 🇦🇷',
              quote: '"Antes tardaba 1 hora planificando la clase del día siguiente. Ahora son 5 minutos."'
            }, {
              init: 'SV',
              name: 'Sofía V.',
              loc: 'Mendoza 🇦🇷',
              quote: '"El Bonus de Seguimiento cambió cómo llevo mis notas. Ahora sé exactamente quién necesita ayuda antes de que sea tarde."'
            }, {
              init: 'DA',
              name: 'Diego A.',
              loc: 'Santa Fe 🇦🇷',
              quote: '"El Élite 1 me salvó con un alumno que traía certificado médico todas las semanas. Supe exactamente qué darle y cómo calificarlo."'
            }, {
              init: 'CR',
              name: 'Carolina R.',
              loc: 'Tucumán 🇦🇷',
              quote: '"El Élite 2 me salvó cuando el directivo me pidió los proyectos de ESI y EAI. Tenía todo listo en 10 minutos."'
            }].map((t, i) => <div key={i} className="bg-gray-50 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col h-full border border-gray-100" data-id="element-203">
                  <div className="flex items-center gap-4 mb-4" data-id="element-204">
                    <div className="w-12 h-12 bg-orange rounded-full flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-205">
                      {t.init}
                    </div>
                    <div data-id="element-206">
                      <p className="font-bold text-navy" data-id="element-207">{t.name}</p>
                      <p className="text-xs text-gray-500" data-id="element-208">{t.loc}</p>
                    </div>
                  </div>
                  <p className="text-gray-600 italic text-sm leading-relaxed flex-grow mb-4" data-id="element-209">
                    {t.quote}
                  </p>
                  <div className="flex gap-1" data-id="element-210">
                    {[...Array(5)].map((_, j) => <Star key={j} className="fill-orange text-orange" size={16} data-id="element-211" />)}
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 10 — GARANTÍA */}
        <section className="py-20 px-4 bg-navy text-white text-center" data-id="element-212">
          <div className="max-w-3xl mx-auto" data-id="element-213">
            <div className="text-6xl mb-6" data-id="element-214">🛡️</div>
            <h2 className="text-3xl md:text-5xl font-black mb-8" data-id="element-215">
              Garantía 7 días sin preguntas
            </h2>

            <div className="space-y-2 text-lg md:text-xl italic text-gray-300 mb-8 font-medium" data-id="element-216">
              <p data-id="element-217">Abrí los 12 Tomos.</p>
              <p data-id="element-218">Revisá los 6 Bonus.</p>
              <p data-id="element-219">Usá los Ebooks Élite en tu clase.</p>
            </div>

            <div className="w-24 h-1 bg-orange mx-auto mb-8 rounded-full" data-id="element-220"></div>

            <p className="text-2xl md:text-3xl font-black mb-8" data-id="element-221">
              Si no es lo que esperabas → 100% de devolución.
            </p>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-electric font-bold text-lg mb-12" data-id="element-222">
              <span data-id="element-223">Sin preguntas.</span>
              <span className="hidden md:inline" data-id="element-224">•</span>
              <span data-id="element-225">Sin formularios.</span>
              <span className="hidden md:inline" data-id="element-226">•</span>
              <span data-id="element-227">Sin drama.</span>
            </div>

            <div className="inline-block bg-green-500/20 text-green-400 border border-green-500/30 px-6 py-3 rounded-full font-black tracking-widest text-sm" data-id="element-228">
              TASA DE DEVOLUCIONES MENOR AL 2%
            </div>
          </div>
        </section>

        {/* SECCIÓN 11 — FAQ */}
        <section className="py-20 px-4 bg-[#F5F5F5]" data-id="element-229">
          <div className="max-w-3xl mx-auto" data-id="element-230">
            <h2 className="text-3xl md:text-4xl font-black text-navy text-center mb-12" data-id="element-231">
              Preguntas Frecuentes
            </h2>

            <div className="space-y-4" data-id="element-232">
              {[{
              q: '¿Cómo recibo el material?',
              a: 'Al completar el pago recibís un email con el acceso inmediato a todos los PDFs. Podés descargarlos en tu celular, tablet o computadora. Acceso de por vida.'
            }, {
              q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
              a: 'Sí para los dos. Si sos nuevo, el sistema te da estructura desde el primer día. Si tenés experiencia, te ahorra el tiempo de planificación semanal.'
            }, {
              q: '¿Los 6 Bonus están en las dos opciones?',
              a: 'Sí. Los 6 Bonus estratégicos están incluidos en el Pack Primaria, el Pack Secundaria y el Megapack Élite. Los 2 Ebooks Élite son exclusivos del Megapack.'
            }, {
              q: '¿Qué diferencia hay con otros materiales que ya existen?',
              a: 'EF360 es el único sistema diseñado específicamente para el docente argentino, con actividades graficadas, planificación anual integrada y recursos para los problemas reales del aula: SAF, ESI, EAI y seguimiento de alumnos.'
            }, {
              q: '¿Sirve para distintos niveles mezclados en el mismo grupo?',
              a: 'Sí. Cada tomo tiene guías de adaptación para grupos con distintos niveles de condición física o experiencia.'
            }, {
              q: '¿Qué pasa si no me sirve?',
              a: 'Tenés 7 días de garantía total. Si no te sirve te devolvemos el 100% sin preguntas.'
            }, {
              q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
              a: 'Si ya planificás bien, el Megapack te da lo que no tenés: la solución para el alumno con certificado SAF y el sistema completo de ESI y EAI para tu planificación oficial. Por $9.000 más, eliminás los dos problemas que más estrés generan al docente de EF.'
            }, {
              q: '¿Puedo pagar con tarjeta de crédito?',
              a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago.'
            }].map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-233" />)}
            </div>
          </div>
        </section>

        {/* SECCIÓN 12 — CTA FINAL */}
        <section className="py-24 px-4 bg-navy text-white text-center" data-id="element-234">
          <div className="max-w-4xl mx-auto" data-id="element-235">
            <div className="text-6xl mb-8" data-id="element-236">📚</div>
            <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight" data-id="element-237">
              EF360 — El sistema de planificación N°1 para profesores de
              Educación Física argentinos.
            </h2>
            <p className="text-xl md:text-2xl text-gray-400 italic mb-12 font-medium" data-id="element-238">
              "Porque preparar una buena clase no debería costarte todas las
              noches de la semana."
            </p>

            <a href="#precio" className="inline-flex items-center justify-center gap-3 bg-orange hover:bg-orange-hover text-white font-black text-xl md:text-3xl py-6 px-10 md:px-16 rounded-full transition-all shadow-[0_0_50px_rgba(255,107,53,0.5)] hover:shadow-[0_0_80px_rgba(255,107,53,0.7)] hover:-translate-y-2 w-full md:w-auto mb-8" data-id="element-239">
              💪 QUIERO MI EF360 AHORA
            </a>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 font-medium" data-id="element-240">
              <span className="flex items-center gap-2" data-id="element-241">
                <Shield size={18} data-id="element-242" /> Garantía 7 días
              </span>
              <span className="hidden md:inline" data-id="element-243">|</span>
              <span className="flex items-center gap-2" data-id="element-244">
                <Lock size={18} data-id="element-245" /> Pago seguro
              </span>
              <span className="hidden md:inline" data-id="element-246">|</span>
              <span className="flex items-center gap-2" data-id="element-247">
                <Zap size={18} data-id="element-248" /> Acceso inmediato
              </span>
            </div>
          </div>
        </section>

        {/* SECCIÓN 13 — FOOTER */}
        <footer className="bg-navy-dark text-white py-12 px-4 text-center" data-id="element-249">
          <div className="max-w-4xl mx-auto" data-id="element-250">
            <div className="font-black text-2xl tracking-tight flex items-center justify-center gap-2 mb-4" data-id="element-251">
              <span className="text-orange" data-id="element-252">🏃</span> EDUCACIÓN FÍSICA 360™
            </div>
            <p className="text-gray-400 italic mb-8 text-sm" data-id="element-253">
              "Porque preparar una buena clase no debería costarte todas las
              noches de la semana."
            </p>

            <div className="flex flex-wrap justify-center gap-6 text-electric font-medium text-sm mb-12" data-id="element-254">
              <span className="flex items-center gap-2" data-id="element-255">
                📧 contacto@ef360.com.ar
              </span>
              <span className="flex items-center gap-2" data-id="element-256">📲 @ef360.ar</span>
              <span className="flex items-center gap-2" data-id="element-257">🌐 www.ef360.ar</span>
            </div>

            <p className="text-gray-600 text-xs" data-id="element-258">
              © EDUCACIÓN FÍSICA 360™ 2025 — Todos los derechos reservados.
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>
        </footer>
      </main>
    </div>;
}
function PricingSelector() {
  const packs = [{
    id: 'primaria',
    emoji: '📘',
    title: 'PACK PRIMARIA',
    subtitle: '6 Tomos Primaria + 6 Bonus',
    oldPrice: '$29.990',
    price: '$16.990',
    cta: 'SÍ, QUIERO EL PACK PRIMARIA'
  }, {
    id: 'elite',
    emoji: '🏆',
    title: 'MEGAPACK ÉLITE',
    subtitle: '12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE',
    oldPrice: '$49.990',
    price: '$27.990',
    featured: true,
    savings: 'AHORRÁS $10.000',
    cta: 'SÍ, QUIERO EL MEGAPACK ÉLITE'
  }, {
    id: 'secundaria',
    emoji: '📗',
    title: 'PACK SECUNDARIA',
    subtitle: '6 Tomos Secundaria + 6 Bonus',
    oldPrice: '$29.990',
    price: '$18.990',
    cta: 'SÍ, QUIERO EL PACK SECUNDARIA'
  }];
  const [selected, setSelected] = useState('elite');
  const selectedPack = packs.find(p => p.id === selected) || packs[1];
  return <div className="bg-white rounded-3xl p-6 md:p-10 shadow-2xl max-w-2xl mx-auto" data-id="element-259">
      <div className="text-center mb-8" data-id="element-260">
        <h3 className="text-3xl md:text-4xl font-black text-navy mb-3" data-id="element-261">
          Elegí tu Pack:
        </h3>
        <p className="text-gray-500 text-base md:text-lg max-w-md mx-auto" data-id="element-262">
          Las tres opciones incluyen los 6 Bonus estratégicos
        </p>
      </div>

      <div className="space-y-4 mb-8" data-id="element-263">
        {packs.map(pack => {
        const isSelected = selected === pack.id;
        return <button key={pack.id} onClick={() => setSelected(pack.id)} className={`w-full text-left rounded-2xl border-2 p-4 md:p-5 transition-all flex items-center gap-3 md:gap-4 ${isSelected ? 'border-orange bg-orange/5 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-264">
              {/* Radio */}
              <div className="shrink-0" data-id="element-265">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'border-orange' : 'border-gray-300'}`} data-id="element-266">
                  {isSelected && <div className="w-3 h-3 rounded-full bg-orange" data-id="element-267"></div>}
                </div>
              </div>

              {/* Content */}
              <div className="flex-grow min-w-0" data-id="element-268">
                <div className="flex items-start gap-2 mb-1" data-id="element-269">
                  <span className="text-xl md:text-2xl shrink-0" data-id="element-270">
                    {pack.emoji}
                  </span>
                  <div className="min-w-0" data-id="element-271">
                    <h4 className="font-black text-navy text-sm md:text-base leading-tight" data-id="element-272">
                      {pack.title}
                    </h4>
                  </div>
                </div>
                {pack.featured && <div className="flex flex-wrap gap-1.5 my-2" data-id="element-273">
                    <span className="inline-flex items-center gap-1 bg-yellow-400 text-yellow-900 font-black px-2 py-0.5 rounded-full text-[10px] md:text-xs" data-id="element-274">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="inline-flex items-center bg-orange/15 text-orange font-black px-2 py-0.5 rounded-full text-[10px] md:text-xs" data-id="element-275">
                      {pack.savings}
                    </span>
                  </div>}
                <p className="text-gray-500 text-xs md:text-sm leading-snug" data-id="element-276">
                  {pack.subtitle}
                </p>
              </div>

              {/* Price */}
              <div className="shrink-0 text-right" data-id="element-277">
                <p className="text-gray-400 line-through text-xs md:text-sm font-medium" data-id="element-278">
                  {pack.oldPrice}
                </p>
                <p className={`font-black text-lg md:text-2xl ${isSelected ? 'text-orange' : 'text-navy'}`} data-id="element-279">
                  {pack.price}
                </p>
              </div>
            </button>;
      })}
      </div>

      {/* Big CTA */}
      <button className="w-full py-5 md:py-6 rounded-2xl bg-orange hover:bg-orange-hover text-white font-black text-base md:text-xl shadow-[0_10px_30px_rgba(255,107,53,0.4)] hover:shadow-[0_15px_40px_rgba(255,107,53,0.5)] transition-all hover:-translate-y-1 flex items-center justify-center gap-3" data-id="element-280">
        {selectedPack.cta}
        <span className="text-2xl" data-id="element-281">→</span>
      </button>

      {selectedPack.featured && <p className="text-center text-gray-400 italic text-sm mt-5" data-id="element-282">
          La opción más elegida por profesores argentinos
        </p>}

      {/* Trust badges */}
      <div className="grid grid-cols-2 gap-3 md:gap-4 mt-8 pt-6 border-t border-gray-100 text-gray-600 text-xs md:text-sm" data-id="element-283">
        <div className="flex items-center gap-2" data-id="element-284">
          <Lock size={16} className="text-gray-400 shrink-0" data-id="element-285" />
          <span className="font-medium" data-id="element-286">Pago seguro</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-287">
          <Zap size={16} className="text-orange shrink-0" data-id="element-288" />
          <span className="font-medium" data-id="element-289">Acceso en 5 min</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-290">
          <Shield size={16} className="text-green-600 shrink-0" data-id="element-291" />
          <span className="font-medium" data-id="element-292">Garantía 7 días</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-293">
          <CreditCard size={16} className="text-gray-400 shrink-0" data-id="element-294" />
          <span className="font-medium" data-id="element-295">Tarjeta · Transferencia</span>
        </div>
      </div>
    </div>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-296">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-297">
        <span className="font-bold text-navy pr-4" data-id="element-298">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="text-orange shrink-0" data-id="element-299">
          <ChevronDown size={20} data-id="element-300" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-301">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-302">
            <div className="px-6 pb-5 text-gray-600 text-sm leading-relaxed border-t border-gray-50 pt-4" data-id="element-303">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}